import React, { useState, useEffect } from "react";
import InputForm from "../../components/common/InputForm";
import TextAreaFieldGroup from "../../components/common/TextAreaFieldGroup";
import { getDateFormat } from "../../components/../helpers/Utils";
import { CheckBoxInput } from "../../components/common/Buttons";
import DatePickerWithHours from "../../components/common/DatePickerWithHours";
import { error } from "../../components/../redux/Actions/modalsFunctios";
import ModalSimple from "../../components/Layout/Modals/ModalSimple";
import {
  callCourrierManifest,
  getSingleManifest,
} from "../../components/../redux/Actions/manifestAction";
import Spinner from "../../components/common/Spinner";
import { useDispatch } from "react-redux";

function DpdManifestModal({ actionId, onClose }) {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [Manifest, setManifest] = useState({});
  const [errorState, setError] = useState(null);
  const [callAction, setCallAction] = useState(false);
  const [times, setTimes] = useState({
    call_time_from: null,
    call_time_to: null,
  });

  useEffect(() => {
    const fetchManifest = async () => {
      const { success, data } = await getSingleManifest(actionId);
      if (success) {
        setManifest(data);
        setLoading(false);
      } else {
        setError("Error occurred");
      }
    };
    setLoading(true);
    fetchManifest();
  }, []);

  const onSubmit = async () => {
    if (callAction) {
      if (!times.call_time_from || !times.call_time_to) {
        error("manifest-e");
        return setError(
          "You have chosen to call a courier at a specified time. Select time"
        );
      }
    }
    const { success, data } = await dispatch(
      callCourrierManifest(actionId, {
        call_action: callAction,
        ...times,
      })
    );
    if (success) {
      onClose();
    } else {
      if (data) setManifest(data);
    }
  };

  if (loading) {
    return (
      <ModalSimple
        status="DPDManifestModal"
        text={"Pickup address"}
        secondButtonText={"Call courier"}
        secondButton={(e) => onSubmit(e)}
        onClose={onClose}
      >
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ height: "100%" }}
        >
          {errorState ? (
            <span className="text-danger">{errorState}</span>
          ) : (
            <Spinner />
          )}
        </div>
      </ModalSimple>
    );
  }
  const pickup_address = Manifest?.pickup_address || {};
  return (
    <ModalSimple
      status="DPDManifestModal"
      text={"Pickup address"}
      secondButtonText={"Call courier"}
      secondButton={(e) => onSubmit(e)}
      onClose={onClose}
    >
      {Manifest.api_errors && (
        <div className="text-danger small">{Manifest.api_errors}</div>
      )}
      <InputForm
        placeholder="Address"
        value={pickup_address.address}
        disabled={true}
      />
      {pickup_address.address2 && (
        <InputForm
          placeholder="Address 2"
          value={pickup_address.address2}
          disabled={true}
        />
      )}
      <InputForm
        placeholder="City"
        value={pickup_address.city}
        disabled={true}
      />
      <InputForm
        placeholder="Code"
        value={pickup_address.code}
        disabled={true}
      />
      <InputForm
        placeholder="Company"
        value={pickup_address.company}
        disabled={true}
      />
      <InputForm
        placeholder="Contact person"
        value={pickup_address.contact_person}
        disabled={true}
      />
      {pickup_address.email && (
        <InputForm
          placeholder="E.mail"
          value={pickup_address.email}
          disabled={true}
        />
      )}
      <InputForm
        placeholder="Mobile phone"
        value={pickup_address.phone}
        disabled={true}
      />
      <div className="bg-light pt-2 pb-1 px-2">
        <CheckBoxInput
          text="Change call time"
          checked={callAction}
          onChange={(e) => setCallAction(e.target.checked)}
        />
        {callAction ? (
          <DatePickerWithHours
            label="Call time"
            value={getDateFormat(times.call_time_from)}
            onChange={(_, r) =>
              setTimes({
                call_time_from: r,
                call_time_to: null,
              })
            }
            value2={times.call_time_to}
            onChange2={(e) =>
              setTimes({
                ...times,
                call_time_to: e,
              })
            }
            error={errorState}
          />
        ) : (
          <InputForm
            placeholder="Working time"
            value={
              pickup_address.pickup_time_from +
              " - " +
              pickup_address.work_time_to
            }
            disabled={true}
          />
        )}
      </div>
      <InputForm
        placeholder="Postal code"
        value={pickup_address.postal_code}
        disabled={true}
      />
      {pickup_address.comment && (
        <TextAreaFieldGroup
          placeholder="Comment"
          value={pickup_address.comment}
          disabled={true}
        />
      )}
    </ModalSimple>
  );
}

export default DpdManifestModal;
